import { gql } from '@apollo/client'

const removeTeamQuoteMutation = gql`
    mutation RemoveQuoteTeamMembership(
        $quoteId: UUID!
        $teamId: Int!
        $userId: Int
    ) {
        removeQuoteTeamMembership(
            quoteId: $quoteId
            teamId: $teamId
            userId: $userId
        ) {
            id
        }
    }
`

export default removeTeamQuoteMutation
